import axios from "axios";

export const getAddresses = async ({ signal }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/addressManagement/getAddresses",
      { signal }
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const createAddress = async ({ signal, input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/addressManagement/createAddress",
      { signal, input }
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const updateAddress = async ({ signal, id, input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/addressManagement/updateAddress",
      { signal, id, input }
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const deleteAddress = async ({ signal, id, input }) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/addressManagement/deleteAddress",
      { signal, id, input }
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};
